import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Manque de trésorerie : causes, conséquences et solutions concrètes | Trezoone',
    description: 'Votre entreprise manque de trésorerie ? Identifiez les causes, mesurez l\'urgence et trouvez les solutions adaptées à votre situation.',
    canonical: '/manque-tresorerie',
    keywords: 'manque trésorerie, manque de trésorerie entreprise, problème trésorerie, rupture trésorerie, manque liquidités',
  },
  hero: {
    tag: 'Manque de trésorerie',
    title: 'Manque de trésorerie : c\'est souvent prévisible. Et souvent évitable.',
    subtitle: 'Un manque de trésorerie se détecte toujours avant qu\'il n\'arrive — à condition d\'avoir les bons outils. Voici comment réagir, et comment ne plus y revenir.',
    ctaLabel: 'Simuler ma situation',
    ctaHref: '/simulateur-tresorerie-association',
  },
  pilierLink: { label: 'Guide gestion de trésorerie', href: '/gestion-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Les 5 causes principales d\'un manque de trésorerie',
      content: 'Un manque de trésorerie a presque toujours une explication identifiable :',
      items: [
        '1. Décalage encaissements/décaissements : vous payez avant d\'être payé',
        '2. Croissance non financée : votre CA augmente mais votre BFR aussi',
        '3. Impayés clients : une ou plusieurs factures non payées qui créent un trou',
        '4. Charges exceptionnelles imprévues : investissement, réparation, litiges',
        '5. Saisonnalité mal gérée : les creux d\'activité ne sont pas provisionnés',
      ],
    },
    {
      type: 'example',
      title: 'Comment réagir selon l\'urgence',
      content: 'La réponse dépend du délai avant la rupture totale :',
      items: [
        'Plus de 6 semaines : temps de négocier un crédit de trésorerie ou un délai fournisseur',
        '3 à 6 semaines : activation du découvert autorisé + affacturage si possible',
        '1 à 3 semaines : relance urgente des impayés + appel à l\'actionnaire ou associé',
        'Moins d\'une semaine : priorité absolue aux paiements obligatoires (salaires, URSSAF)',
        'Dans tous les cas : ne jamais attendre passivement. Informer la banque en avance.',
      ],
    },
    {
      type: 'midcta',
      title: 'Manque de trésorerie dans 6 semaines ? Trezoone vous le dit aujourd\'hui — pas trop tard',
      content: 'La prévision de trésorerie sur 12 mois de Trezoone détecte les creux à venir et vous laisse le temps d\'agir.',
    },
    {
      type: 'solution',
      title: 'Anticiper pour ne plus subir',
      content: 'Le meilleur traitement du manque de trésorerie, c\'est la prévention. Trezoone vous y aide.',
      items: [
        'Prévision de trésorerie sur 12 mois → vous voyez le creux 6 semaines à l\'avance',
        'Indicateur "temps de survie" → combien de semaines à charges constantes',
        'Alertes automatiques quand le solde prévu descend sous un seuil',
        'Simulation de scénarios → testez l\'impact d\'un impayé avant qu\'il arrive',
        'Rapport PDF pour aller voir votre banquier en position de force',
      ],
    },
    {
      type: 'cluster',
      title: 'Tout pour éviter la rupture de trésorerie',
      links: [
        { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
        { label: 'Prévision de trésorerie', href: '/prevision-tresorerie' },
        { label: 'Simulateur trésorerie', href: '/simulateur-tresorerie-association' },
        { label: 'Problème cash flow', href: '/probleme-cash-flow' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'BFR et trésorerie', href: '/bfr-tresorerie' },
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Ne gérez plus votre trésorerie dans l\'urgence',
      content: 'Anticipez. Simulez. Agissez avant. Trezoone, essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
    { label: 'Prévision de trésorerie', href: '/prevision-tresorerie' },
    { label: 'Simulateur trésorerie', href: '/simulateur-tresorerie-association' },
    { label: 'Problème cash flow', href: '/probleme-cash-flow' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'BFR et trésorerie', href: '/bfr-tresorerie' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
    { label: 'Cash flow entreprise', href: '/cash-flow-entreprise' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function ManqueTresoreriePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
